import React, { useState, useEffect } from "react";
import useWindowDimensions from "../../../../../../components/get-diemensions/UseWindowDiemensions";
import {
  BaseButtons,
  CloseButton,
  TextInputField,
  TextInputFieldSearch,
} from "../../../../../../components/atoms";

import { BlackAndWhite } from "../../../../../../themes/Colors";
import { CalenderSelector, LoadingPopUp } from "../../../../../../components";

const TipsDisplay = ({ auth, storeArray }) => {
  const { width, height } = useWindowDimensions();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedInventoryProduct, setSelecetdInventoryProduct] =
    useState(null);

  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState("");
  const [tipRecieptsArray, setTipRecieptsArray] = useState([]);

  const [popUpHover, setPopUpHover] = useState(false);
  // store variables
  const [selectedStore, setSelectedStore] = useState("");

  const [inventoryItemsArray, setInventoryItemsArray] = useState(null);
  const [productItemsArray, setProductItemsArray] = useState(null);
  const [recipetsArray, setRecipetsArray] = useState(null);
  const [stockTakeTickets, setStocktakeTickets] = useState([]);
  const [transfersArray, setTransferArray] = useState([]);

  const [selectedItemrecipetsArray, setselectedItemrRecipetsArray] = useState(
    []
  );
  const [selectedItemrstockTakeTickets, setselectedItemrStocktakeTickets] =
    useState([]);
  const [selectedItemrtransfersArray, setselectedItemrtransfersArray] =
    useState([]);
  const [selectedItemFullTransferArray, setselectedItemFullTransferArray] =
    useState([]);
  const [selectedItemFullReceipt, setselectedItemFullReceipt] = useState([]);

  const [amountSales, setAmountSales] = useState(null);
  const [amountSalesvalue, setAmountSalesValue] = useState(null);
  const [storeUsers, setStoreUsers] = useState(null);

  const [startingDate, setStartingDate] = useState(new Date());
  const [endingDate, setEndingDate] = useState(new Date());

  const [startingDay, setStartingDay] = useState(
    new Date().toISOString().substring(8, 10)
  );

  const [startingDaycheck, setStartingDaycheck] = useState(
    new Date().toISOString().substring(8, 10)
  );
  const [startingMonth, setStartingMonth] = useState(
    new Date().toISOString().substring(5, 7)
  );
  const [startingYear, setStartingYear] = useState(
    new Date(startingDate).toISOString().substring(0, 4)
  );

  const [dateSelectorPopUp, setDateSelectorPopUp] = useState(false);
  const [periodSelected, setPeriodSelected] = useState("Custom");
  const [refresh, setRefresh] = useState(false);
  const [customDay, setCustomDay] = useState("1");

  // tip slip displays

  const [selectedButender, setSelectedBudtender] = useState(null);
  const [tipsArray, settipsArray] = useState(null);

  console.log("storeUsers", storeUsers);

  const NameAssemble = ({ productId }) => {
    let product;
    if (productItemsArray) {
      productItemsArray.map((item) =>
        item._id === productId ? (product = item) : null
      );
    }

    if (product) {
      let name =
        product.productName +
        " | " +
        product.productSubType +
        " | " +
        product.thcType +
        " | " +
        product.thcContent;
      return name;
    }
  };

  //   const selectProductCheck = ({ productId }) => {
  //     setLoading(true);
  //     let product;
  //     if (productItemsArray) {
  //       productItemsArray.map((item) =>
  //         item._id === productId ? (product = item) : null
  //       );
  //     }

  //     if (product) {
  //       setLoading(false);
  //       return product;
  //     }
  //   };

  // get inventory reporting base\
  const getTipReceiptForUser = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/processSale/getUserTipReceipts",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: selectedButender._id,
            endDate: startingDate,
            daysBack: customDay,
          }),
        }
      );
      const respnseData = await response.json();

      if (respnseData.success) {
        setTipRecieptsArray(respnseData.receipts);
        setLoading(false);
        // setStoreArray(respnseData.stores);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("test", err);
    }
  };
  const getSalesItemAmountAndValue = ({ productId }) => {
    let qtyAmount = [];
    let stock = 0;

    // console.log("chcek data in side amount chcek");

    for (let index = 0; index < selectedItemrecipetsArray.length; index++) {
      const element = selectedItemrecipetsArray[index];

      qtyAmount.push(Number(element.qtyCard.qty));
    }

    let qtyAmountSld = qtyAmount.reduce(function (x, y) {
      return x + y;
    }, 0);

    if (productItemsArray) {
      productItemsArray.map((item) =>
        item._id === productId ? (stock = item.retailPriceInc) : null
      );
    }

    let amount = stock * qtyAmountSld;
    // console.log("amount", amount);
    // console.log("QTY", qtyAmountSld);
    setAmountSalesValue(qtyAmountSld);
    setAmountSales(amount);

    return { amount: amount, qtyAmount: qtyAmountSld };
  };
  const ReturnStockAmount = ({ productId, qty }) => {
    let stock = 0;
    if (productItemsArray) {
      productItemsArray.map((item) =>
        item._id === productId ? (stock = item.baseCostPrice) : null
      );
    }

    let amount = stock * qty;

    return String(amount.toFixed(2));
  };

  const returnProductReceipts = ({ productId }) => {
    setLoading(true);

    if (recipetsArray) {
      for (let index = 0; index < recipetsArray.length; index++) {
        const element = recipetsArray[index];

        for (let i = 0; i < element.productsArray.length; i++) {
          const elementItem = element.productsArray[i];
          if (elementItem.qtyCard.productId === productId) {
            selectedItemrecipetsArray.push(elementItem);
            selectedItemFullReceipt.push(element);
          }
        }
      }
    }
    setLoading(false);
    return selectedItemrecipetsArray;
  };

  const GetStoreUsers = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/processSale/getAllStoreUsers",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            storeName: auth.storeName,
            storeId: selectedStore ? selectedStore.storeId : null,
            adminCheck: "true",
          }),
        }
      );

      const responseData = await response.json();

      if (responseData.success) {
        setStoreUsers(responseData.storeUsers);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  useEffect(() => {
    GetStoreUsers();
  }, [selectedStore]);

  useEffect(() => {
    getTipReceiptForUser();
  }, [selectedButender, refresh]);

  //   const returnStockTakeTickets = ({ productId }) => {
  //     if (stockTakeTickets) {
  //       for (let index = 0; index < stockTakeTickets.length; index++) {
  //         const element = stockTakeTickets[index];

  //         if (element.productId === productId) {
  //           selectedItemrstockTakeTickets.push(element);
  //         }
  //       }
  //     }
  //     if (selectedItemrecipetsArray.length === 0) {
  //       setLoading(false);
  //     }
  //     return selectedItemrstockTakeTickets;
  //   };
  //   const returnData = () => {
  //     return {
  //       selectedItemrtransfersArray: selectedItemrtransfersArray,
  //       selectedItemrstockTakeTickets: selectedItemrstockTakeTickets,
  //       selectedItemrecipetsArray: selectedItemrecipetsArray,
  //     };
  //   };
  // set period and get data over period
  //   useEffect(() => {
  //     // here is where the approval fileds will be added for review
  //     if (selectedStore) {
  //       getInventoryData();
  //     }
  //   }, [selectedStore]);

  //   useEffect(() => {
  //     // here is where the approval fileds will be added for review
  //     if (amountSales === 0 && selectedProduct) {
  //       //   getInventoryData();

  //       getSalesItemAmountAndValue({ productId: selectedProduct._id });
  //     } else {
  //       return;
  //     }
  //   }, [amountSales]);
  return (
    <div
      style={{
        height: height - 70,
        width: width,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
      }}
    >
      <div
        style={{
          width: "100%",
          minHeight: 50,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ minWidth: 5 }} />
        <TextInputFieldSearch
          height={28}
          borderRadius={4}
          placeholder={"search product here"}
        />
        <BaseButtons
          label={"CLEAR"}
          mini={true}
          borderRadius={4}
          size={80}
          marginTopFalse={true}
          height={35}
          marginLeft={5}
        />
        <BaseButtons
          label={"SEARCH"}
          mini={true}
          borderRadius={4}
          size={80}
          marginTopFalse={true}
          height={35}
          marginLeft={5}
        />
        <div style={{ flex: 1 }} />

        <div
          style={{
            flexDirection: "row",
            display: "flex",
            width: "100%",
            alignItems: "center",
            color: "black",
            minHeight: 55,
            justifyContent: "flex-end",
            // backgroundColor: "#00000050",
            // borderStyle: "solid",
          }}
        >
          <BaseButtons
            label={"REFRESH"}
            mini={true}
            // marginTop={5}
            fontSize={12}
            borderRadius={4}
            marginLeft={5}
            minHeight={45}
            marginTopFalse={true}
            height={45}
            size={120}
            borderWidth={0}
            onClick={() => {
              setRefresh(refresh ? false : true);
            }}
          />
          <div
            style={{
              fontSize: 12,
              fontWeight: "bold",
              marginLeft: 5,
              marginRight: 5,
            }}
          >
            {`REPORT FOR ${customDay} DAY/S`}
          </div>
          <div
            style={{
              height: 50,
              // borderStyle: "solid",
              // width: 200,
              marginRight: 10,
              paddingLeft: 10,
              paddingRight: 10,
              display: "flex",
              alignItems: "center",
            }}
          >
            <div style={{ marginRight: 10, display: "flex" }}>
              {dateSelectorPopUp ? (
                <div style={{ position: "relative" }}>
                  <div
                    style={{
                      position: "absolute",
                      zIndex: 2000,
                      top: -5,
                      left: -5,
                    }}
                  >
                    <CloseButton
                      label={"X"}
                      invert={true}
                      height={40}
                      width={40}
                      onClick={() => setDateSelectorPopUp(false)}
                    />
                  </div>
                  <CalenderSelector
                    startingDate={startingDate}
                    setStartingDate={setStartingDate}
                    setDateSelectorPopUp={setDateSelectorPopUp}
                  />
                </div>
              ) : (
                <div>
                  {/* <div
                          style={{
                            fontSize: 10,
                            opacity: 0.6,
                            fontWeight: "bold",
                            width: "100%",
                            marginBottom: 3,
                          }}
                        >
                          DATE SELECTOR
                        </div> */}
                  <BaseButtons
                    label={startingDate.toDateString()}
                    mini={true}
                    minHeight={45}
                    height={45}
                    marginTopFalse={true}
                    borderRadius={4}
                    size={100}
                    // marginTop={5}
                    // disable={periodSelected === "2" ? true : false}
                    onClick={() => setDateSelectorPopUp(true)}
                  />
                </div>
              )}
            </div>
            {/* <div style={{ position: "relative" }}>
                      <BaseButtons
                        label={`${periodSelected} days`}
                        mini={true}
                        marginTopFalse={true}
                        borderRadius={8}
                        marginRight={periodSelected === "Custom" ? 10 : 0}
                        minHeight={45}
                        height={45}
                        size={120}
                        invert={false}
                        // onClick={() => {
                        //   setPeriodOpen(true);
                        // }}
                      />
                      <div
                        style={{
                          display: "flex",
                          height: periodOpen ? 200 : 0,
                          // borderStyle: "solid",
                          flexDirection: "column",
                          zIndex: 10000000000000,
                          position: "absolute",
                          overflow: "hidden",
                          alignItems: "center",
                          width: 120,
                        }}
                      >
                        <BaseButtons
                          label={"TODAY"}
                          mini={true}
                          marginTop={4}
                          // borderRadius={8}
                          // marginRight={10}
                          minHeight={30}
                          height={30}
                          size={"100%"}
                          invert={periodSelected === "1" ? false : true}
                          onClick={() => {
                            setPeriodSelected("1");
                            setStartingDate(new Date());
                            setPeriodOpen(false);
                          }}
                        />
                        {/* <BaseButtons
                        label={"YESTERDAY"}
                        mini={true}
                        marginTop={4}
                        // borderRadius={8}
                        // marginRight={10}
                        minHeight={30}
                        height={30}
                        size={"100%"}
                        invert={periodSelected === "2" ? false : true}
                        onClick={() => {
                          setPeriodSelected("2");
                          setStartingDate(new Date());
                          setPeriodOpen(false);
                        }}
                      /> */}
            {/* <BaseButtons
                      label={"7 DAYS"}
                      mini={true}
                      // marginTop={1}
                      marginTopFalse={true}
                      // borderRadius={8}
                      // marginRight={10}
                      minHeight={30}
                      height={30}
                      size={"100%"}
                      invert={periodSelected === "7" ? false : true}
                      onClick={() => {
                        setPeriodSelected("7");
                        setPeriodOpen(false);
                      }}
                    /> */}
            {/* <BaseButtons
                      label={"30 DAYS"}
                      mini={true}
                      // marginTop={1}
                      marginTopFalse={true}
                      // borderRadius={8}
                      // marginRight={10}
                      minHeight={30}
                      height={30}
                      size={"100%"}
                      invert={periodSelected === "30" ? false : true}
                      onClick={() => {
                        setPeriodSelected("30");
                        setPeriodOpen(false);
                      }}
                    /> */}
            {/* <BaseButtons
                      label={"CUSTOM"}
                      mini={true}
                      // marginTop={-1}
                      marginTopFalse={true}
                      // borderRadius={8}
                      // marginRight={10}
                      minHeight={30}
                      height={30}
                      size={"100%"}
                      invert={periodSelected === "Custom" ? false : true}
                      onClick={() => {
                        setPeriodOpen(false);
                        setPeriodSelected("Custom");
                      }}
                    /> */}
            {/* </div>
                    </div> */}
            {periodSelected === "Custom" ? (
              <TextInputField
                mini={true}
                labelTitle={"DAYS?"}
                height={17}
                fontsizeLabel={10}
                invert={true}
                marginTop={1}
                size={35}
                type={"number"}
                paddingRight={5}
                onChange={(e) => setCustomDay(String(e.target.value))}
                value={customDay}
              />
            ) : null}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginRight: 10,
            position: "relative",
          }}
        >
          <div style={{ fontSize: 14, marginRight: 10 }}>STORE</div>
          <BaseButtons
            mini={true}
            marginTopFalse={true}
            height={30}
            label={
              selectedStore === "ALL" ||
              selectedStore === "warehouse" ||
              !selectedStore
                ? selectedStore
                : selectedStore.storeName
            }
            borderRadius={4}
            size={220}
            onClick={() => setSelectedStore(null)}
          />
        </div>
      </div>
      {/* // header */}
      <div
        style={{
          width: "100%",
          height: 40,
          backgroundColor: BlackAndWhite.primary,
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            flex: 0.2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: BlackAndWhite.secondary,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "left",
          }}
        >
          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ minWidth: 20 }} />
            STAFF NAME
          </div>
        </div>
        <div
          style={{
            flex: 0.15,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: BlackAndWhite.secondary,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "left",
          }}
        >
          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ minWidth: 20 }} />
            {/* CURRENTLY HOLDING */}
          </div>
        </div>
        <div
          style={{
            flex: 0.15,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: BlackAndWhite.secondary,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "left",
          }}
        >
          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ minWidth: 20 }} />
            {/* HOLDING VALUE */}
          </div>
        </div>
        <div
          style={{
            flex: 0.15,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: BlackAndWhite.secondary,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "left",
          }}
        >
          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ minWidth: 20 }} />
            {/* SLIP COUNT */}
          </div>
        </div>
        <div
          style={{
            flex: 0.15,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: BlackAndWhite.secondary,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "left",
          }}
        >
          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ minWidth: 20 }} />
            {/* PERIOD TOTAL */}
          </div>
        </div>
        <div
          style={{
            flex: 0.2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: BlackAndWhite.secondary,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "left",
          }}
        >
          <div>ACTIONS</div>
        </div>
      </div>
      <div
        style={{
          flex: 1,

          width: "100%",
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        {storeUsers
          ? storeUsers.length >= 1
            ? storeUsers.map((item, index) => {
                return (
                  <div
                    onClick={() => {
                      setSelectedBudtender(item);
                      setTipRecieptsArray([]);
                    }}
                    key={index}
                    style={{
                      width: "100%",
                      minHeight: 40,
                      borderBottomWidth: 1,
                      borderBottomStyle: "solid",
                      display: "flex",
                      alignItems: "center",
                      borderColor: "#00000050",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        minHeight: 40,
                        alignItems: "center",
                      }}
                    >
                      <div style={{ flex: 0.4 }}>
                        <div style={{ marginLeft: 20 }}>
                          {item.firstName} {item.lastName}
                        </div>
                      </div>
                      <div style={{ flex: 0.4 }} />
                      <div
                        style={{
                          flex: 0.2,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          // color: BlackAndWhite.secondary,
                          fontSize: 10,
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        <div>VIEW</div>
                      </div>
                    </div>

                    {selectedButender && selectedButender._id === item._id ? (
                      <div
                        style={{
                          minHeight: tipRecieptsArray
                            ? tipRecieptsArray.length >= 10
                              ? 400
                              : null
                            : null,
                          width: "100%",
                          //   borderStyle: "solid",
                          overflowY: "scroll",
                          overflowX: "hidden",
                          borderTopStyle: "solid",
                        }}
                      >
                        {tipRecieptsArray
                          ? tipRecieptsArray.length >= 1
                            ? tipRecieptsArray.map((item, index) => {
                                return (
                                  <div
                                    key={index}
                                    style={{
                                      display: "flex",
                                      width: "100%",
                                      borderBottomStyle: "solid",
                                      borderBottomWidth: 1,
                                      borderColor: "#00000050",
                                      alignItems: "center",
                                      minHeight: 40,
                                    }}
                                  >
                                    <div style={{ flex: 0.2 }}>
                                      <div style={{ marginLeft: 20 }}>
                                        <div
                                          style={{
                                            fontSize: 10,
                                            fontWeight: "bold",
                                            marginBottom: 2,
                                            opacity: 0.7,
                                          }}
                                        >
                                          Date
                                        </div>
                                        <div>
                                          {item.dateTime.substring(0, 10)}
                                        </div>
                                      </div>
                                    </div>
                                    <div style={{ flex: 0.2 }}>
                                      <div
                                        style={{
                                          fontSize: 10,
                                          fontWeight: "bold",
                                          marginBottom: 2,
                                          opacity: 0.7,
                                        }}
                                      >
                                        Customer
                                      </div>
                                      <div>{item.customerName}</div>
                                    </div>
                                    <div style={{ flex: 0.4 }}>
                                      <div
                                        style={{
                                          fontSize: 10,
                                          fontWeight: "bold",
                                          marginBottom: 2,
                                          opacity: 0.7,
                                        }}
                                      >
                                        Slip No
                                      </div>
                                      <div>{item.slipNo}</div>
                                    </div>
                                    <div style={{ flex: 0.2 }}>
                                      <div style={{ marginLeft: 20 }}>
                                        <div
                                          style={{
                                            fontSize: 10,
                                            fontWeight: "bold",
                                            marginBottom: 2,
                                            opacity: 0.7,
                                          }}
                                        >
                                          Tip Amount
                                        </div>
                                        <div>R {item.changeAmount}</div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            : "No tips found"
                          : null}
                      </div>
                    ) : null}
                  </div>
                );
              })
            : null
          : "loading"}
        {/* <div> this will be all the stores and the the users</div> */}
      </div>
      {/* <ItemReportDisplay
        loading={loading}
        display={selectedProduct}
        setClose={setSelectedProduct}
        selectedItemrecipetsArray={selectedItemrecipetsArray}
        selectedItemrstockTakeTickets={selectedItemrstockTakeTickets}
        selectedItemrtransfersArray={selectedItemrtransfersArray}
        setSelecetdInventoryProduct={setSelecetdInventoryProduct}
        selectedInventoryProduct={selectedInventoryProduct}
        productItemsArray={productItemsArray}
        amountSales={amountSales}
        amountSalesvalue={amountSalesvalue}
        selectedItemFullTransferArray={selectedItemFullTransferArray}
        selectedItemFullReceipt={selectedItemFullReceipt}
      /> */}
      {/* // store slection pop up */}
      {!selectedStore ? (
        <div
          onClick={popUpHover ? null : () => setSelectedStore("ALL")}
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "#00000030",
            position: "absolute",
            top: 0,
            display: "flex",
          }}
        >
          <div
            onMouseOver={() => setPopUpHover(true)}
            onMouseOut={() => setPopUpHover(false)}
            style={{
              minWidth: 300,
              maxWidth: 300,
              paddingTop: 10,
              paddingBottom: 20,
              borderRadius: 4,
              backgroundColor: BlackAndWhite.secondary,
              maxHeight: 400,
              overflowY: "scroll",
              overflowX: "hidden",
              right: 10,
              top: 10,
              position: "absolute",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <BaseButtons
                label={"Warehouse"}
                mini={true}
                marginTopFalse={true}
                borderRadius={4}
                height={30}
                minHeight={30}
                size={"90%"}
                onClick={() => setSelectedStore("warehouse")}
              />
            </div>
            {storeArray
              ? storeArray.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        marginTop: index === 0 ? 0 : 10,
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <BaseButtons
                        label={item.storeName}
                        mini={true}
                        marginTopFalse={true}
                        borderRadius={4}
                        height={30}
                        minHeight={30}
                        size={"90%"}
                        onClick={() => setSelectedStore(item)}
                      />
                    </div>
                  );
                })
              : "no stores avlible"}
          </div>
        </div>
      ) : null}
      <LoadingPopUp display={loading} newWidth={"100%"} />
    </div>
  );
};

export default TipsDisplay;
